import { render } from "./ExchangePair.vue?vue&type=template&id=d63eebc0&scoped=true"
import script from "./ExchangePair.vue?vue&type=script&lang=js"
export * from "./ExchangePair.vue?vue&type=script&lang=js"

import "./ExchangePair.vue?vue&type=style&index=0&id=d63eebc0&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-d63eebc0"

export default script